import React, { useRef, useEffect } from 'react';
import { NoContentMessage } from '../../../editor-ui/baseComponents';
import { Heading, Icon, EditorContainer, fieldType } from './helpers';

export default function ImageField({ field }) {
  const fieldRef = useRef(null);
  const containerId = `js-image-field-${field.id}`;

  useEffect(() => {
    if (window.page && fieldRef.current && field.assetPresent){
      window.page.init(
        "ImageFieldView",
        {
          el: document.getElementById(containerId),
          asset: {
            asset_id: field.assetId,
            persisted: true,
            assetableType: "Field",
            assetableId: field.id,
            url: field.assetUrl,
            title: field.assetName,
            allowDelete: false
          }
        }
      );
    }
  }, [fieldRef, field.id, field.assetPresent, field.assetId, field.assetUrl, field.assetName]);

  return (
    <React.Fragment>
      <Heading>
        <Icon type="image" />
        { field.name }
      </Heading>
      <EditorContainer
        id={containerId}
        ref={fieldRef}
        className="custom-field-container"
      >
        {!field.assetPresent && <NoContentMessage contentType="image" />}
      </EditorContainer>
    </React.Fragment>
  );
}

ImageField.propTypes = {
  field: fieldType.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/customFields/ImageField.jsx